import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import PageHero from "@/components/feature/PageHero";
import CtaBand from "@/components/feature/CtaBand";
import { externalLinks, images } from "@/mocks/site";
import {
  LocavoreIdea,
  LocavorePeople,
  LocavoreChapters,
} from "@/pages/locavore/components/LocavoreSections";

export default function LocavorePodsPage() {
  return (
    <SiteLayout>
      <PageHero
        eyebrow="World 02 · The Movement"
        title={
          <>
            LOCAVORE
            <br />
            PODS
          </>
        }
        subtitle="The people, places, food and businesses behind a local food movement — introduced here, explored at locavorepods.com."
        image={images.kitchenCrew}
        imageClassName="object-center"
        meta={
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
            <a
              href={externalLinks.locavorePods}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Explore Locavore PODS
              <i className="ri-arrow-right-up-line text-base" />
            </a>
            <Link
              to="/bring-eddie"
              className="btn-ghost text-background-50/85 hover:bg-background-50 hover:text-foreground-950"
            >
              Nominate a Locavore
            </Link>
          </div>
        }
      />

      <LocavoreIdea />
      <LocavorePeople />
      <LocavoreChapters />

      <CtaBand
        eyebrow="The Movement Lives Elsewhere"
        title={
          <>
            This is the doorway.
            <br />
            <span className="italic text-primary-400">Step through it.</span>
          </>
        }
        text="CHEF.TV introduces the Locavore world — the full platform, its people and its pods live over at locavorepods.com."
        externalPrimary={{
          label: "Explore Locavore PODS",
          href: externalLinks.locavorePods,
        }}
        secondary={{ label: "Submit a Locavore", to: "/submit-a-locavore" }}
      />
    </SiteLayout>
  );
}